import { defineStore } from 'pinia'
import { ref } from 'vue'
import axios from 'axios'

export const useAuthStore = defineStore('auth', () => {
    const isAuthenticated = ref(false)
    const AdminEmail = ref("")
    const Token = ref("")
    const isSuperAdmin = ref(false)
    const authChecked = ref(false)

    async function getMe() {
        try {
            const res = await axios.get('/api/auth/me', { withCredentials: true})
            const info = res.data
            AdminEmail.value = info.email
            if(info.role == "superadmin") isSuperAdmin.value = true
            isAuthenticated.value = true
            return info
        } catch(err: any) {
                AdminEmail.value = ""
                isAuthenticated.value = false
                isSuperAdmin.value = false
        }finally{
            authChecked.value = true
        }
    }

    async function login(email: string, password: string) {
        try {
            const token = await axios.post('/api/auth/login', {email, password}, { withCredentials: true})
            Token.value = token.data
            await this.getMe()
        } catch(err: any) {
            isAuthenticated.value = false
        }

        return isAuthenticated.value
    }

    async function logout() {
        try {
            isAuthenticated.value = false
            isSuperAdmin.value = false
            await axios.post('/api/auth/logout', {}, { withCredentials: true})
        } catch(err: any) {
        }
    }

    return { isAuthenticated, isSuperAdmin, AdminEmail, authChecked, login, logout, getMe }
})
